import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f2da5818"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2 mb-2" }),
  /*#__PURE__*/_createTextVNode("เอกสารแนบ:")
], -1))
const _hoisted_4 = { class: "list-group" }
const _hoisted_5 = {
  key: 0,
  class: "list-group-item text-center text-danger"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }, null, -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-paperclip me-2" }, null, -1))
const _hoisted_9 = { class: "mb-3" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "far fa-images me-2 mb-2" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "list-group"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "list-group-item text-center text-danger" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fas fa-exclamation-triangle me-2" }),
  /*#__PURE__*/_createTextVNode("ไม่มีข้อมูล ")
], -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseOffcanvasComponent = _resolveComponent("BaseOffcanvasComponent")!

  return (_openBlock(), _createBlock(_component_BaseOffcanvasComponent, {
    ref: "attachmentOffcanvas",
    placement: "right"
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode("เอกสารการยกเลิกโครงการ ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("ul", _hoisted_4, [
          (_ctx.attachments?.length === 0)
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _hoisted_6,
                _createTextVNode("ไม่มีข้อมูล ")
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.attachments, (attachment, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: "list-group-item text-truncate"
                }, [
                  _createElementVNode("a", {
                    href: attachment.file,
                    target: "_blank"
                  }, [
                    _hoisted_8,
                    _createTextVNode(_toDisplayString(attachment.name), 1)
                  ], 8, _hoisted_7)
                ]))
              }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createTextVNode("รูปประกอบ: "),
        _createElementVNode("div", null, [
          (_ctx.images.length === 0)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_11, _hoisted_13))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.images, (image, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  key: index,
                  href: image.file,
                  "data-lightbox": "cancel-images"
                }, [
                  _createElementVNode("img", {
                    src: image.file,
                    class: "image-content",
                    alt: `image-${index}`
                  }, null, 8, _hoisted_15)
                ], 8, _hoisted_14))
              }), 128))
        ])
      ])
    ]),
    _: 1
  }, 512))
}